import Socket from '../helpers/Socket';
import Lot from '../helpers/Lot';
import Timer from '../helpers/Timer';

window.socket = new Socket();

window.socket
    .listen('lots.update', Lot.update)
    .listen('lots.create', Lot.create)
    .listen('lots.delete', Lot.delete)
    .listen('timestamp', Timer.update)
